export default __webpack_public_path__ + "static/media/MaterialCommunityIcons.a7629910.ttf";